import type { Forecast } from "./types";
import { ForecastError, getApiBaseUrl } from "./client";

export async function getForecast(
  lat: number,
  lon: number,
  units: "us" | "si" = "us",
): Promise<Forecast> {
  const url = new URL("/v1/forecast", getApiBaseUrl());
  url.searchParams.set("lat", String(lat));
  url.searchParams.set("lon", String(lon));
  url.searchParams.set("units", units);

  const response = await fetch(url, {
    headers: { Accept: "application/json" },
    signal: AbortSignal.timeout(10_000),
  });

  if (!response.ok) {
    throw new ForecastError(response.status, await response.json().catch(() => null));
  }

  return response.json() as Promise<Forecast>;
}
